<!-- Action row: Like, Dislike + Copy/Speaker/Share/Options (below timestamp) -->
<div class="toolbar">
 
    <button type="button"
            *ngIf="showFeedback"
            class="t-bottom t-no-arrow btn-value-components"
            [attr.aria-label]="'LIKE_BUTTON_TOOLTIP' | translate"
            [ngClass]="{'icon-selected': isLikeSelected}"
            [disabled]="disabled"
            (click)="onLike()">
      <img [src]="likeThumbsIcon" alt="thumbs-up" class="icon-thumbs-up icon-default"/>
    </button>
    <button type="button"
            *ngIf="showFeedback"
            class="t-bottom t-no-arrow btn-value-components"
            [attr.aria-label]="'UNLIKE_BUTTON_TOOLTIP' | translate"
            [ngClass]="{'icon-selected': isDislikeSelected}"
            [disabled]="disabled"
            (click)="onDislike()">
      <img [src]="dislikeThumbsIcon" alt="thumbs-down" class="icon-thumbs-down icon-default"/>
    </button>
    <!-- Projected actions: audio, copy, share (e.g. from agent or chatbot) -->
    <ng-content select="[responseActions]"></ng-content>
  
</div>

<!-- Dislike feedback form (shown when dislike is selected) -->
<div class="row" *ngIf="showFeedbackForm">
  <div class="feed-back-section" *ngIf = "!isAgent">
    <p class="m-t-0 m-b-10">{{ 'UNLIKE_FEEDBACK_TITLE_TEXT' | translate }}</p>
    <div class="row" *ngIf="!commentsOnly">
      <ul class="feedback-list">
        <li *ngFor="let item of options; let k = index">
          <input type="checkbox"
                 [id]="'control_fb_' + (responseId ?? '') + '_' + item.Id"
                 [name]="'select_fb_' + (responseId ?? '') + '_' + item.Id"
                 [value]="item.Id"
                 [(ngModel)]="item.IsChecked" />
          <label [for]="'control_fb_' + (responseId ?? '') + '_' + item.Id">
            {{ (item.Name === 'Incorrect Response' ? ('UNLIKE_FEEDBACK_LABEL_1' | translate) :
                item.Name === 'Incorrect References' ? ('UNLIKE_FEEDBACK_LABEL_2' | translate) :
                item.Name === 'Missing Information' ? ('UNLIKE_FEEDBACK_LABEL_3' | translate) :
                item.Name === 'Irrelevant' ? ('UNLIKE_FEEDBACK_LABEL_4' | translate) :
                item.Name === 'Partially Correct Response' ? ('UNLIKE_FEEDBACK_LABEL_5' | translate) :
                item.Name) }}
          </label>
        </li>
      </ul>
    </div>

    <div class="row display-inline-block">
      <div class="form-group m-t-10">
        <label [for]="'additionalComments_fb_' + (responseId ?? '')" class="label">{{ 'ADDITIONAL_COMMENTS_TEXT' | translate }}</label>
        <textarea [id]="'additionalComments_fb_' + (responseId ?? '')"
                  class="form-control"
                  [(ngModel)]="additionalComments"
                  cols="3"
                  [placeholder]="'ADDITIONAL_COMMENTS_PLACEHOLDER' | translate"></textarea>
        <span *ngIf="showOptionError && !commentsOnly && !isAnyOptionChecked()" class="error_message">
          {{ 'ATLEAST_ONE_OPTION_TOASTER_MSG' | translate }}
        </span>
      </div>
    </div>

    <div class="row display-inline-block">
      <div class="form-group m-t-20 text-right pull-right">
        <a href="#" class="btn btn-secondary-outline" (click)="onFeedbackCancel(); $event.preventDefault()">{{ 'CANCEL_BUTTON_TEXT' | translate }}</a>
        <a href="#" class="btn btn-primary m-l-10" (click)="onFeedbackSubmit(); $event.preventDefault()">{{ 'SUBMIT_BUTTON_TEXT' | translate }}</a>
      </div>
    </div>
  </div>
</div>

<!-- Agent feedback popup template – attached to overlay so it covers whole screen (escapes parent transform). -->
<ng-template #feedbackPopupTemplate>
  <div class="popup-backdrop" tabindex="-1" (click)="onClosFeedbackPopup()" (keydown)="onFeedbackPopupKeydown($event)">
    <div class="popup popup-feedback" (click)="$event.stopPropagation()" (keydown)="onFeedbackPopupKeydown($event)">
      <div class="popup-header-feedback">
        <button (click)="onClosFeedbackPopup()" class="feedback-popup-close"> <img src="../../../assets/images/cross.svg" alt ="crossIcon" width="24"></button>
      </div>
      <div class="popup-content-feedback">
        <textarea
          [(ngModel)]="feedbackInputValue"
          [maxlength]="feedbackInputMaxLength"
          [placeholder]="'FEEDBACK_POPUP_PLACEHOLDER' | translate"
          class="feedback-input"
          rows="5"></textarea>
      </div>
      <div class="popup-bottom-feedback">
        <div class="feedback-char-count">
          <span>{{ feedbackInputCount }} / {{ feedbackInputMaxLength }}</span>
        </div>
        <div class="feedback-actions">
          <button type="button" class="feedback-btn-skip" (click)="onFeedbackSkip(); $event.preventDefault()">{{'SKIP_BUTTON_TEXT'| translate}}</button>
          <button type="button" class="feedback-btn-submit"
                  [disabled]="isAgent && !feedbackInputValue.trim()"
                  (click)="onFeedbackSubmit(); $event.preventDefault()">{{'FEEDBACK_POPUP_SUBMIT_BUTTON'| translate}}</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
